export type TestimonialType = {
  authorAvatarSrc: string;
  authorName: string;
  address: string;
  orgLogoSrc?: string;
  feedback: string;
};

export enum CreateAccountFlowType {
  signUp,
  signUpByInvitationLink,
  acceptInviteFromEmail,
}
